module.exports = __webpack_public_path__ + "img/ic_teacher_shisheng.3430ab38.png";